import { render, staticRenderFns } from "./landDetailCopy.vue?vue&type=template&id=406754da&scoped=true"
import script from "./landDetailCopy.vue?vue&type=script&lang=js"
export * from "./landDetailCopy.vue?vue&type=script&lang=js"
import style0 from "./landDetailCopy.vue?vue&type=style&index=0&id=406754da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406754da",
  null
  
)

export default component.exports